<div class="card">
    <!-- HEADER TOOLBAR -->
    <p-toolbar class="mb-3" [style]="{ 'background-color': '#f3f4f6', border: '0' }">
        <ng-template pTemplate="start">
            <div class="font-semibold text-2xl">Tolleranze L94</div>
        </ng-template>
        <ng-template pTemplate="end">
            <div class="flex items-center gap-2">
                <button pButton label="Nuova tolleranza" icon="pi pi-plus" [size]="'large'" (click)="onNuovo()"></button>
            </div>
        </ng-template>
    </p-toolbar>

    <!-- DATA TABLE -->
    <p-table
        #dt
        [value]="l94Items"
        dataKey="id"
        [paginator]="true"
        [rows]="10"
        [rowsPerPageOptions]="[5, 10, 20, 50]"
        [resizableColumns]="true"
        [responsiveLayout]="'stack'"
        [scrollable]="true"
        styleClass="p-datatable-striped p-datatable-sm"
        [globalFilterFields]="['sigla', 'dettaglio']"
    >
        <ng-template pTemplate="caption">
            <div class="flex justify-between items-center">
                <span class="text-sm text-500"></span>
                <span class="p-input-icon-left">
                    <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')" placeholder="Cerca…" />
                </span>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th pResizableColumn pSortableColumn="sigla">Sigla <p-sortIcon field="sigla"></p-sortIcon></th>
                <th pResizableColumn pSortableColumn="dettaglio">Dettaglio <p-sortIcon field="dettaglio"></p-sortIcon></th>
                <th style="width: 220px">Azioni</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
            <tr>
                <td>{{ item.sigla }}</td>
                <td>{{ item.dettaglio }}</td>
                <td>
                    <div class="flex gap-2">
                        <button pButton icon="pi pi-pencil" [size]="'large'" severity="warn" pTooltip="Modifica" (click)="onModifica(item)"></button>
                        <button pButton icon="pi pi-trash" [size]="'large'" severity="danger" pTooltip="Elimina" (click)="onElimina(item)"></button>
                    </div>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="3" class="text-center">Nessun elemento trovato</td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-toast position="top-right"></p-toast>
<p-confirmDialog [style]="{ width: '450px' }" rejectButtonStyleClass="p-button-text" acceptLabel="Elimina" rejectLabel="Annulla" header="Confermi l'eliminazione?" icon="pi pi-exclamation-triangle"> </p-confirmDialog>
